import HttpKit from '@/utils/http-kit'

export default {

  /**
   * 首页所有信息
   * /portalCli/home
   * @param No parameters
   */
  home () {
    return HttpKit.post('/api/portalCli/home', {
    }).then(
      res => res.data
    )
  },
  bidNews() {
    return HttpKit.post('/api/portalCli/home/bidNews', {
    }).then(
      res => res.data
    )
  },
  lawNews() {
    return HttpKit.post('/api/portalCli/home/lawNews', {
    }).then(
      res => res.data
    )
  },
  levelList() {
    return HttpKit.post('/api/portalCli/home/levelList', {
    }).then(
      res => res.data
    )
  },
  integrityList() {
    return HttpKit.post('/api/portalCli/home/integrityList', {
    }).then(
      res => res.data
    )
  },

  /**
   * 获取加盟单位
   * /portalCli/home/college
   * @param keyword
   * @param current
   * @param size
   * @param areaScope 所在地区（01华南；02华北；03华东；04华中；05西北；06东北；07西南)
   * @param collegeName 加盟单位名称
   * @param sourceType 加盟单位类型（C：学校，E：企业，O 事业单位；H:医疗机构；S：科研机构）
   * @param isRedis
   * @param inProvince 省份
   * @returns {Promise<T>}
   */
  college (keyword, current, size, areaScope, collegeName, sourceType,isRedis, inProvince = []) {
    return HttpKit.post('/api/portalCli/home/college', {
      keyword: keyword,
      current: current,
      size: size,
      condition: {
        areaScope: areaScope,
        collegeName: collegeName,
        sourceType: sourceType,
        isRedis:isRedis?'Y':'N',
        inProvince
      }
    }).then(
      res => res.data
    )
  },

  /**
   * 优质供应商
   * /portalCli/home/level
   * @param keyword
   * @param current
   * @param size
   * @param companyLevel 优质级别
   * @param companyName 企业名称
   * @param endElectYear 评定年度end
   * @param startElectYear 评定年度start
   */
  level (keyword, current, size, companyLevel, companyName, endElectYear, startElectYear) {
    return HttpKit.post('/api/portalCli/home/level', {
      keyword: keyword,
      current: current,
      size: size,
      condition: {
        companyLevel: companyLevel,
        companyName: companyName,
        endElectYear: endElectYear,
        startElectYear: startElectYear
      }
    }).then(
      res => res.data
    )
  },

  /**
   * 获取即将截止
   * /portalCli/home/ending
   */
  ending () {
    return HttpKit.post('/api/portalCli/home/ending', {
    }).then(
      res => res.data
    )
  },

  /**
   * 获取正在竞价
   * /portalCli/home/purchase
   * @param keyword  查询关键字(add by 梁展鹏 20190321 暂时用不上)
   * @param current 当前页
   * @param size 每页记录数(默认每页10条)
   * @param procurementType 采购内容A：通用设备；D科研仪器；E实验试剂；F耗材；B工程；C服务；G租售
   * @param sourceType C：学校的订单，E：企业的订单，O 事业单位；H:医疗机构；S：科研机构
   * @param collegeNameList 单位所在地
   */
  purchase (keyword, current, size, procurementType, sourceType, collegeNameList, selectType) {
    return HttpKit.post('/api/portalCli/home/purchase', {
      keyword: keyword,
      current: current,
      size: size,
      condition: {
        procurementType: procurementType,
        sourceType: sourceType,
        collegeNameList: collegeNameList,
        selectType
      }
    }).then(
      res => res.data
    )
  },

  /**
   * 获取最新推荐
   * /portalCli/home/recommend
   */
  recommend () {
    return HttpKit.post('/api/portalCli/home/recommend', {
    }).then(
      res => res.data
    )
  },

  /**
   * 获取竞价结果
   * /portalCli/home/result
   * @param keyword  查询关键字(add by 梁展鹏 20190321 暂时用不上)
   * @param current 当前页
   * @param size 每页记录数(默认每页10条)
   * @param procurementType 采购内容A：通用设备；D科研仪器；E实验试剂；F耗材；B工程；C服务；G租售
   * @param sourceType C：学校的订单，E：企业的订单，O 事业单位；H:医疗机构；S：科研机构
   * @param collegeNameList 单位所在地
   * @param startBidresultTime 中标时间start
   * @param endBidresultTime 中标时间end
   */
  result (keyword, current, size, procurementType, sourceType, collegeNameList, startBidresultTime, endBidresultTime) {
    return HttpKit.post('/api/portalCli/home/result', {
      keyword: keyword,
      current: current,
      size: size,
      condition: {
        procurementType: procurementType,
        sourceType: sourceType,
        collegeNameList: collegeNameList,
        startBidresultTime: startBidresultTime,
        endBidresultTime: endBidresultTime
      }
    }).then(
      res => res.data
    )
  },

  /**
   * 首页所有信息
   * /portalCli/home/top
   */
  top () {
    return HttpKit.post('/api/portalCli/home/top', {
    }).then(
      res => res.data
    )
  },
  /**
   * 首页重要公告
   * /portalCli/home/topNotice
   */
  topNotice () {
    return HttpKit.post('/api/portalCli/home/topNotice', {
    }).then(
      res => res.data
    )
  },

  /**
   * 获取跳转按钮
   * /portalCli/home/button
   */
  button () {
    return HttpKit.post('/api/portalCli/home/button', {
    }).then(
      res => res.data
    )
  },

  /**
   * 竞价数据
   * /portalCli/home/count
   */
  count () {
    return HttpKit.post('/api/portalCli/home/count', {
    }).then(
      res => res.data
    )
  },

  /**
   * 获取商场新品
   * /portalCli/home/goods
   * @param typeId 商品分类ID(在首页`/portalCli/home`的接口响应goodsTypeList带出)
   */
  goods (typeId) {
    return HttpKit.post('/api/portalCli/home/goods', {
      typeId: typeId
    }).then(
      res => res.data
    )
  },
  /**
   * 获取隐私政策
   * /loginCli/privacy
   *
   */
  privacy () {
    return HttpKit.post('/api/loginCli/privacy', {
    }).then(
      res => res.data
    )
  },
  /**
   * 获取商场新品
   *
   /portalCli/home/goods
   */
  goodsList (typeId) {
    return HttpKit.post('/api/portalCli/home/goods', {
      typeId: typeId
    }).then(
      res => res.data
    )
  },
  // 获取置顶店铺
  storeList () {
    return HttpKit.post('/api/portalCli/home/storeList', {}).then(
      res => res.data
    )
  },

  // 获取试剂耗材推荐

  reagent () {
  return HttpKit.post('/api/portalCli/home/reagent', {
  }).then(
    res => res.data
  )
},

  // 验证短信验证码
  checkSmsCode (data) {
    return HttpKit.post('/api/collegeCli/expert/checkSmsCode', data).then(
    res => res.data
  )},

  // 发送短信验证码
  sendSmsCode (data) {
    return HttpKit.post('/api/collegeCli/expert/sendSmsCode', data).then(
    res => res.data
  )},

  // 专家注册
  register (data) {
    return HttpKit.post('/api/collegeCli/expert/register', data).then(
    res => res.data
  )},
  // 专家注册滑块验证码
  getSlideImage (data) {
    return HttpKit.post('/api/collegeCli/expert/getSlideImage', data).then(
    res => res.data
  )},

  // 专家登录验证码
  loginSmsCode (data) {
    return HttpKit.post('/api/collegeCli/expert/login/smsCode', data).then(
    res => res.data
  )},
  // 专家注销
  expertLogout (data) {
    return HttpKit.post('/api/collegeCli/expert/logout', data).then(
    res => res.data
  )},
  // 专家注册
  expertLogin (data) {
    return HttpKit.post('/api/collegeCli/expert/login', data).then(
    res => res.data
  )},

  // 咨询我们滑块验证码
  getContractSlideImage (data) {
  return HttpKit.post('/api/portalCli/contactUs/getSlideImage', data).then(
    res => res.data
  )},

  // 咨询发送短信
  contactUsSendSmsCode (data) {
    return HttpKit.post('/api/portalCli/contactUs/sendSmsCode', data).then(
    res => res.data
  )},

  // 咨询提交联系人信息
  submitContactInfo (data) {
    return HttpKit.post('/api/portalCli/contactUs/submitContactInfo', data).then(
    res => res.data
  )},

// 获取商场类别
  NewGoodsType () {
    return HttpKit.post('/api/portalCli/home/goodsType', {
    }).then(
      res => res.data
    )
  },

  saveReadInfo (data) {
    return HttpKit.post('/api/portalCli/readInfo/saveReadInfo', data).then(
      res => res.data
    )
  },

  collegeCount (data) {
    return HttpKit.post('/api/portalCli/home/collegeCount', data).then(
      res => res.data
    )
  },
  getProductIntroduction (data) {
    return HttpKit.post('/api/portalCli/home/getProductIntroduction', data).then(
      res => res.data
    )
  },
  getProductIntroductionDetail (data, config) {
    return HttpKit.post('/api/portalCli/home/getProductIntroductionDetail', data, config).then(
      res => res.data
    )
  },

}




// WEBPACK FOOTER //
// ./src/api/home.js